import { EuroCoinIcon, GiftIcon, TruckIcon } from '@synergy/theme-next';
import { FormattedMessage } from 'react-intl';
import { PoolRow } from '@synergy/components-next';
import { ReactElement, ReactNode } from 'react';
import { Stack } from '@mui/material';

import { PaymentTermText } from '../../../../components/payment-term-text/payment-term-text';

export interface TooltipConditionsProps {
    conditions?: ReactNode;
    termsOfDelivery?: string;
    termsOfPayment?: string;
    isChargingSupplier: boolean;
}

export const Conditions = (props: TooltipConditionsProps): ReactElement => {
    const { conditions, termsOfDelivery, termsOfPayment, isChargingSupplier } = props;

    return (
        <Stack gap={2} typography="body2">
            {termsOfDelivery && (
                <Stack gap={0.5}>
                    <PoolRow>
                        <TruckIcon />
                        <strong>
                            <FormattedMessage id="app.cart.supplier.termsOfDelivery" />
                        </strong>
                    </PoolRow>
                    {termsOfDelivery}
                </Stack>
            )}
            {termsOfPayment?.length && (
                <Stack gap={0.5}>
                    <PoolRow>
                        <EuroCoinIcon />
                        <strong>
                            <FormattedMessage id="app.cart.supplier.termsOfPayment" />
                        </strong>
                    </PoolRow>
                    <PaymentTermText isChargingSupplier={isChargingSupplier} paymentTerm={termsOfPayment} />
                </Stack>
            )}

            {conditions && (
                <Stack gap={0.5}>
                    <PoolRow>
                        <GiftIcon />
                        <strong>
                            <FormattedMessage id="app.cart.supplier.conditionsOfPurchase" />
                        </strong>
                    </PoolRow>
                    {conditions}
                </Stack>
            )}
        </Stack>
    );
};
